/**
 * NotLinkedScreen (S0a) — shown when /session returns NOT_PAIRED.
 * Props: { ctx, api, tg, nav, state, setState, params } (see App.jsx).
 *
 * REPLACES the retired PIN pairing screen. Linking now happens in the BOT
 * BEFORE the Mini App is opened: the worker taps Start in @stroykent_ishchi_bot,
 * shares their phone once, and the bot links them to their hr.employee. So if we
 * ever land here it means they opened the app before finishing that one-time
 * step — we don't ask for a PIN, we point them back to the bot and offer a
 * re-check once they've shared their phone.
 *
 *   - "Botni ochish" → tg.openTelegramLink(bot) (or a new tab in a dev browser).
 *   - "Qayta tekshirish" → nav.reboot() (re-runs /session after they've linked).
 */
import Screen from '../components/Screen.jsx';
import Button from '../components/Button.jsx';
import { T } from '../lib/i18n.js';

// The onboarding bot; overridable per-deploy, defaults to the live worker bot.
const BOT_USERNAME = import.meta.env.VITE_BOT_USERNAME || 'stroykent_ishchi_bot';
const BOT_LINK = `https://t.me/${BOT_USERNAME}`;

export default function NotLinkedScreen({ tg, nav }) {
  return (
    <Screen
      title={T.notlinked_title}
      bodyClass="consent"
      footer={
        <>
          <Button onClick={() => { tg.haptic('light'); tg.openTelegramLink(BOT_LINK); }}>
            {T.btn_open_bot}
          </Button>
          <Button variant="ghost" onClick={() => nav.reboot()}>
            {T.btn_recheck}
          </Button>
        </>
      }
    >
      <div className="cn-ic">📱</div>
      <div className="cn-h">{T.notlinked_h}</div>
      <div className="cn-b">{T.notlinked_b}</div>
      <div className="cn-steps">
        <div>{T.notlinked_step1}</div>
        <div>{T.notlinked_step2}</div>
        <div>{T.notlinked_step3}</div>
      </div>
      <div className="cn-pills">
        <span>{T.notlinked_once}</span>
      </div>
    </Screen>
  );
}
